import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition, HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetOrdersSettingsResponse,
  OrdersSettings,
  OrdersSettingsUpdatedEnvelope,
  UpdateOrdersSettingsResponse,
  getOrdersSettings as universalGetOrdersSettings,
  updateOrdersSettings as universalUpdateOrdersSettings,
} from './ecom-v1-orders-settings-orders-settings.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function getOrdersSettings(
  httpClient: HttpClient
): GetOrdersSettingsSignature {
  return () =>
    universalGetOrdersSettings(
      // @ts-ignore
      { httpClient }
    );
}

interface GetOrdersSettingsSignature {
  /**
   * Retrieves the sites' order settings.
   *
   *
   * The `getOrdersSettings()` function returns a Promise that resolves to orders settings.
   * @returns The requested orders settings.
   */
  (): Promise<
    NonNullablePaths<
      GetOrdersSettingsResponse,
      `ordersSettings.inventoryUpdateTrigger`,
      3
    >
  >;
}

export function updateOrdersSettings(
  httpClient: HttpClient
): UpdateOrdersSettingsSignature {
  return (ordersSettings: OrdersSettings) =>
    universalUpdateOrdersSettings(
      ordersSettings,
      // @ts-ignore
      { httpClient }
    );
}

interface UpdateOrdersSettingsSignature {
  /**
   * Updates the sites' orders settings.
   *
   *
   * The `updateOrdersSettings()` function returns a Promise that resolves to the newly updated orders settings.
   * @param - Orders settings to update.
   * @returns The updated orders settings.
   */
  (ordersSettings: OrdersSettings): Promise<
    NonNullablePaths<
      UpdateOrdersSettingsResponse,
      `ordersSettings.inventoryUpdateTrigger`,
      3
    >
  >;
}

export const onOrdersSettingsUpdated = EventDefinition(
  'wix.ecom.v1.orders_settings_updated',
  true,
  (event: OrdersSettingsUpdatedEnvelope) =>
    renameKeysFromRESTResponseToSDKResponse(
      transformPaths(event, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
            { path: 'modifiedFields.createdDate' },
            { path: 'modifiedFields.updatedDate' },
          ],
        },
      ])
    )
)<OrdersSettingsUpdatedEnvelope>();

export {
  AccountInfo,
  AccountInfoMetadata,
  ActionEvent,
  BaseEventMetadata,
  DeleteOrdersSettingsRequest,
  DeleteOrdersSettingsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  EventMetadata,
  GetOrdersSettingsRequest,
  GetOrdersSettingsResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  InventoryUpdateTrigger,
  ListOrdersSettingsRequest,
  ListOrdersSettingsResponse,
  MessageEnvelope,
  OrdersSettings,
  OrdersSettingsUpdatedEnvelope,
  RestoreInfo,
  UpdateOrdersSettingsRequest,
  UpdateOrdersSettingsResponse,
  WebhookIdentityType,
} from './ecom-v1-orders-settings-orders-settings.universal.js';
